import React from 'react'
import Banner22 from '../../Common/Banner2'
import img1111 from "../../../Assets/Images/member_0003.png"
// import img1111 from "../../../Assets/Images/memberimg.png"
import Membermain from '../member/membermain'
import Mreason from "../member/mreason"
import Member_Map from '../member/memberMap'
import MemberNotice from '../member/memberNotice'
import MemberNotice2 from '../member/memberNotice2'
// import FREEVersion from './FREEVersion'
//import img1 from "../../../../Assets/Images/freeimg.png";

import MemberMap from './memberMap'
import { useNavigate } from "react-router-dom";
import { RoutesString } from "../../Modules/routesString";
import * as Scroll from "react-scroll"
function Member() {
  const scroll = Scroll.animateScroll
  return (
    <main>

       
        <Banner22
        img1111={img1111}
        title={`나만의 프라이빗 문의함 CSbye `}
        subTitle="나의 문의 상황과 이전 내역을 한 번에 확인하고 싶다면?"
        detail={``}

       textButton={"일반회원 로그인하기"}
        onPressButton={() => {{alert('준비중입니다.')}}}
          // scroll.scrollToTop()
          // navigation(RoutesString.Customer);       
        textButton2={"포인트 교환하기 (준비중)"}
        // textButton={"서비스 문의하기"}
        backgroundColor="#63aeff"
      />
      
      
      <Member_Map/>
      <Mreason/>
      <Membermain/>
      <MemberNotice/>
      <MemberNotice2/>
      
      
      {/* <FREEplatform/> */}
      {/* <Policy /> */}
    </main>
  )
}




//function Free() {
  //return (
    //<main>
      //  <Banner
        //img={img}
 //       title={`CSbye 플랫폼 평생무료!`}
   //     subTitle="문의량이 적은 소규모, 스타트업 기업이라면?"
     //   detail={``}
       // onPressButton={() => {alert('준비중입니다.')}}
     //   textButton={"CSbye플랫폼 시작하기"}
   //     backgroundColor="#c1e0ff"
    //  />
     // <FREEmain />
 //   </main>
//  )
//}


//const Free = () => {
  //return (
    //<div id="star" className="bg-f2f3f8">
      //무료이용중
     
    //</div>

  //);
  

//};

export default Member;
